import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Sorting } from 'Blocks'

class MobileSortByView extends Component {
  static propTypes = {
    location: PropTypes.any
  }

  render() {
    return (
      <div className="filter-panel__filter panel">
        <Sorting
          location={this.props.location}
          className="filter-panel__menu"
        />
      </div>
    )
  }
}

export default MobileSortByView
